import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
	useBooleanState,
	usePendingNotificationsQueueStore,
} from '@mopla/utils';

import { MplButton } from '../../atoms/MplButton';
import { BusDelayAnim } from '../../molecules/Animations';
import { MplModal } from '../MplModal';
import { usePassengerRoutingHelpers } from '../WithPassengerRoutingHelpers';

export const TripDelayModal = () => {
	const { t } = useTranslation();
	const { navigateToTickets } = usePassengerRoutingHelpers();

	const [isNotificationOpened, openNotification, closeNotification] =
		useBooleanState(false);

	const delay = usePendingNotificationsQueueStore((state) => state.delay);
	const clearDelay = usePendingNotificationsQueueStore(
		(state) => state.clearDelay
	);

	/** Processes delay notification whenever delay appears */
	useEffect(() => {
		if (!delay) return;

		openNotification();

		navigateToTickets({ bookingNumber: delay.bookingNumber });

		clearDelay();
	}, [delay, openNotification, navigateToTickets, clearDelay]);

	return (
		<MplModal
			open={isNotificationOpened}
			icon={<BusDelayAnim />}
			title={t('notifications:push.delay.title')}
			content={t('notifications:push.delay.info')}
			testId="TripDelayModal"
			buttons={
				<MplButton onClick={closeNotification} fullWidth>
					{t('common:button.ok')}
				</MplButton>
			}
		/>
	);
};
